import React from 'react';
import MixedChart from './mixedchart';
import Button from '@material-ui/core/Button';
import get from 'lodash/get';
import { withStyles } from '@material-ui/core/styles';
import { TYPE_COLORS } from '../../common/constants';
import Color from 'color';

const FIELDS = ['GP$', 'UPT', 'Hourly Customers'];

const styles = {
  tabs: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridColumnGap: '10px',
  },
  buttons: {
    borderRadius: 0,
  },
};

const PerformanceChart = ({ pprs, classes }) => {
  const [chosen, setChosen] = React.useState('GP$');
  const [actuals, setActuals] = React.useState([]);
  const [targets, setTargets] = React.useState([]);
  const [max, setMax] = React.useState(5000);
  const [weeks, setWeeks] = React.useState([]);
  const [state, setState] = React.useState({ chartColors: undefined });

  React.useEffect(() => {
    console.log('PPRS: ', pprs);
    setWeeks(pprs.map(ppr => ppr.period.name));
  }, [pprs]);

  React.useEffect(() => {
    switch (chosen) {
      case 'GP$':
        setActuals(pprs.map(ppr => get(ppr, 'actualWeeklyGp', 0)));
        setTargets(pprs.map(ppr => get(ppr, 'targetWeeklyGp', 0)));
        setMax(1000);
        break;
      case 'UPT':
        setActuals(pprs.map(ppr => get(ppr, 'actualWeeklyUpt', 0)));
        setTargets(pprs.map(ppr => get(ppr, 'targetWeeklyUpt', 0)));
        setMax(1);
        break;
      case 'Hourly Customers':
        setActuals(pprs.map(ppr => get(ppr, 'actualHourLyCustomers', 0)));
        setTargets(pprs.map(ppr => get(ppr, 'targetHourLyCustomers', 0)));
        setMax(5);
        break;
      default:
        break;
    }
    setState(oldState => {
      const typeColor = TYPE_COLORS.find(tc => tc.label === chosen);
      const chartColors = [
        typeColor.bgColor,
        Color(typeColor.bgColor)
          .lighten(0.2)
          .hex(),
      ];
      return {
        ...oldState,
        chartColors,
      };
    });
  }, [chosen, pprs]);

  const handleChange = id => setChosen(id);

  function getButtonStyle(field) {
    let buttonStyle;
    if (chosen === field) {
      buttonStyle = {
        color: get(state, 'chartColors.0'),
        borderColor: get(state, 'chartColors.1'),
      };
    }
    return buttonStyle;
  }
  return (
    <>
      <div className={classes.tabs}>
        {FIELDS.map(field => (
          <Button
            classes={{ root: classes.buttons }}
            style={getButtonStyle(field)}
            variant="outlined"
            onClick={() => handleChange(field)}
            key={field}
          >
            {field}
          </Button>
        ))}
      </div>
      <MixedChart
        actuals={actuals}
        targets={targets}
        weeks={weeks}
        max={max}
        colors={state.chartColors}
      />
    </>
  );
};

export default withStyles(styles)(PerformanceChart);
